import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Button, Spinner} from "reactstrap";
import {useSelector} from "react-redux";
import {Close, HelpOutline} from "@material-ui/icons";
import DETAILS from "@constants/shopDetails";
import WebPaths from "@router/paths/web";
import {handleToggle} from "@utils/handleToggle";
import {contactMethodsLinks} from "@utils/types/contactMethodsTypes";
import SetInnerHtml from "@components/setInnerHtml";
import "./style.scss";
import {FiPhoneCall} from "react-icons/fi";

const FloatingContact = () => {
    const [isOpen, setIsOpen] = useState(false);

    const navigate = useNavigate();

    const contactMethods = useSelector(state => state.UI.general?.social_media);

    const primaryContactMethods = contactMethods?.filter(contactMethod => parseInt(contactMethod.is_primary));

    return (
        <div className="floating-contact">
            {isOpen &&
                <div className="floating-contact-content">
                    <div className="floating-contact-content-body">
                        <h2 className="floating-contact-content-body-title">
                            ارتباط با
                            {` ${DETAILS.name}`}
                        </h2>
                        <span className="floating-contact-content-body-description">{DETAILS.description}</span>
                        <hr/>
                        {primaryContactMethods?.length > 0 ?
                            <div className='d-flex justify-content-between flex-wrap'>
                                {primaryContactMethods?.map((item) =>
                                    <Button className='floating-contact-content-body-button'>
                                        <a
                                            key={item.id}
                                            href={contactMethodsLinks(item.type, item.value)}
                                            rel="noreferrer"
                                            target="_blank"
                                            title={`${item.title}: ${item.value}`}
                                            className="d-flex align-items-center p-50"
                                        >
                                            <SetInnerHtml html={item.icon} className="d-flex"/>
                                            <span className="ml-1 font-medium-1 text-dark">{item.title}</span>
                                        </a>
                                    </Button>
                                )}
                            </div>
                            :
                            <Spinner/>
                        }
                    </div>

                    <div className="floating-contact-content-footer">
                        <Button.Ripple
                            outline
                            className="w-100 btn-whatsapp"
                            onClick={() => {
                                navigate(WebPaths.contactUs);
                                handleToggle(setIsOpen);
                            }}
                        >
                            مشاهده سایر راه های ارتباطی
                        </Button.Ripple>
                    </div>
                </div>
            }

            <button
                className="floating-contact-button"
                onClick={() => handleToggle(setIsOpen)}
                title="تماس و پشتیبانی"
                aria-label="تماس و پشتیبانی"
            >
                {isOpen ?
                    <Close/>
                    :
                    <FiPhoneCall size={25}/>
                }
            </button>
        </div>
    )
}

export default FloatingContact;